import React, { memo, useState } from "react";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import Avtar from "./Avtar";
import Dropdown from "react-bootstrap/Dropdown";
import IframeModal from "../PopupModal/IframeModal";
import DropDownAction from "../GeneralFunctions/DropDownAction";

function PeoplesTile({
  peopleName,
  people,
  inClass,
  fullObject,
  photoUrl,
  onDropdownToggle,
}) {
  const {
    webUrlSubDomain,
    role,
    attendees,
    setShowIframe,
    setShowUrl,
    setLoading,
    __merchantId,
    attendeesLookup,
    callN,
    isInstructorMode,
    isInstructorModeRef,
    toggleStates, grp
  } = useLiveStreamAppContext();

  const { handleAction } = DropDownAction();

  const currentAttendee = callN.current?.remoteParticipants.find(
    (participant) => participant.identifier.communicationUserId === people
  );

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleToggle = (isOpen) => {
    setIsDropdownOpen(isOpen);
    onDropdownToggle?.(isOpen); // Notify parent of state change
  };

  //function to Show only the first name in the List
  function getFirstName(displayName) {
    return displayName.split(" ")[0];
  }

  const getAttendeeProperty = (communicationUserId, property) => {
    const attendee = attendees.find(
      (att) => att.communicationUserId === communicationUserId
    );
    return attendee ? attendee[property] : false;
  };
  const displayUserProfile = async (participant) => {
    let matchingAttendee = attendeesLookup[participant];
    if (process.env.REACT_APP_PARENT_DOMAIN?.trim().toLowerCase() === "bookitall.com") {
      setShowUrl(process.env.REACT_APP_WEB_URL_SUBDOMAIN + "ShopOwner/LiveStreamReactVagaroPopup.aspx?popuptype=customer&businessidenc=" + __merchantId + "&useridenc=" + matchingAttendee.userId + "&isLivestreamForReact=1");
    }
    else {
      setShowUrl("https://" + grp + "." + process.env.REACT_APP_PARENT_DOMAIN + "/ShopOwner/LiveStreamReactVagaroPopup.aspx?popuptype=customer&businessidenc=" + __merchantId + "&useridenc=" + matchingAttendee.userId + "&isLivestreamForReact=1");
    }
    setShowIframe(true); // Show profile after alert
    setLoading(true);
  };

  return (
    <>
      <div className="attendee-section">
        <div className="attendee-name-pic">
          <Avtar
            people={fullObject}
            userName={peopleName}
            photoUrl={photoUrl}
          />
          <div className="avtar-name">{peopleName}</div>
        </div>
        {(role === "Presenter" ||
          (!isInstructorModeRef.current && role === "Attendee")) && (
            <div className="attendee-menu three-dot-menu mobile-dropdown-menu attendeeMenu">
              <Dropdown onToggle={handleToggle}>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  className="btn-3dot"
                  aria-expanded={isDropdownOpen}
                >
                  <i className="icon font-awesome-normal-pro va-dot-menu"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu className="attendeeOptions">
                  {role === "Presenter" && inClass ? (
                    <>
                      <Dropdown.Item
                        onClick={() =>
                          handleAction(
                            currentAttendee?.isMuted ? "Unmute" : "Mute",
                            people
                          )
                        }
                        disabled={currentAttendee?.isMuted}
                      >
                        <div className="attendee-icon-menu">
                          <div className="icon-block">
                            <svg
                              fill="currentColor"
                              className="___12fm75w_v8ls9a0 f1w7gpdv fez10in fg4l7m0"
                              aria-hidden="true"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 10a3 3 0 0 1-.1.78L7 4.88A3 3 0 0 1 13 5v5ZM7 7.7V10a3 3 0 0 0 4.74 2.45l1.07 1.07A4.5 4.5 0 0 1 5.5 10a.5.5 0 0 0-1.01 0 5.5 5.5 0 0 0 5 5.48v2.02a.5.5 0 0 0 1 0v-2.02a5.48 5.48 0 0 0 3.02-1.25l3.63 3.62a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7L7 7.71Zm7.8 4.98c.45-.8.7-1.7.7-2.68a.5.5 0 0 0-1 0c0 .7-.16 1.35-.44 1.94l.74.74Z"
                                fill="currentColor"
                              ></path>
                            </svg>
                          </div>
                          Mute
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() =>
                          handleAction(
                            !currentAttendee?.videoStreams[0]?.isAvailable
                              ? "EnableVideo"
                              : "DisableVideo",
                            people
                          )
                        }
                        disabled={!currentAttendee?.videoStreams[0]?.isAvailable}
                      >
                        <div className="attendee-icon-menu">
                          <div className="icon-block">
                            <i className="fa-regular fa-video-slash"></i>
                          </div>
                          Disable Video
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() =>
                          handleAction(
                            getAttendeeProperty(people, "isChatDisabled")
                              ? "EnableChat"
                              : "DisableChat",
                            people
                          )
                        }
                        disabled={!toggleStates.EnableChat}
                      >
                        <div className="attendee-icon-menu ">
                          <div className="icon-block">
                            {getAttendeeProperty(people, "isChatDisabled") ? (
                              <i className="font-awesome-light-pro va-comment-lines"></i>
                            ) : (
                              <i
                                className="fa-regular fa-comment-slash"
                                aria-hidden="true"
                              ></i>
                            )}
                          </div>

                          {getAttendeeProperty(people, "isChatDisabled")
                            ? "Enable Chat"
                            : "Disable Chat"}
                        </div>
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() =>
                          handleAction(
                            getAttendeeProperty(people, "isScreenShareDisabled")
                              ? "EnableScreenShare"
                              : "DisableScreenShare",
                            people
                          )
                        }
                        disabled={
                          isInstructorMode || !toggleStates.EnableScreenShare
                        }
                      >
                        <div className="attendee-icon-menu ">
                          <div className="icon-block">
                            <svg
                              fill="currentColor"
                              className="___12fm75w_v8ls9a0 f1w7gpdv fez10in fg4l7m0"
                              aria-hidden="true"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                              focusable="false"
                            >
                              <path
                                d="M4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4Zm6 10a.5.5 0 0 1-.5-.5V7.7L7.85 9.36a.5.5 0 1 1-.7-.7l2.5-2.5c.2-.2.5-.2.7 0l2.5 2.5a.5.5 0 0 1-.7.7L10.5 7.71v5.79a.5.5 0 0 1-.5.5Z"
                                fill="currentColor"
                              ></path>
                            </svg>
                          </div>
                          {getAttendeeProperty(people, "isScreenShareDisabled")
                            ? "Enable Screen Share"
                            : "Disable Screen Share"}
                        </div>
                      </Dropdown.Item>

                      <Dropdown.Item
                        href="#"
                        onClick={() => displayUserProfile(people)}
                      >
                        <div className="attendee-icon-menu ">
                          <div className="icon-block">
                            <i
                              data-icon-name="PeoplePaneAddPerson"
                              aria-hidden="true"
                              className="ms-ContextualMenu-icon icon-250"
                            >
                              <i
                                className="fa-solid fa-user"
                                aria-hidden="true"
                              ></i>
                            </i>
                          </div>
                          {getFirstName(peopleName)}
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() =>
                          handleAction(
                            getAttendeeProperty(people, "isPinned")
                              ? "Unpin"
                              : "Pin",
                            people
                          )
                        }
                      >
                        <div className="attendee-icon-menu ">
                          <div
                            className="icon-block"
                            style={
                              getAttendeeProperty(people, "isPinned")
                                ? {}
                                : { paddingTop: "2px" }
                            }
                          >
                            {getAttendeeProperty(people, "isPinned") ? (
                              <i className="fa-regular fa-thumbtack-slash"></i>
                            ) : (
                              <i className="fa-regular fa-thumbtack"></i>
                            )}
                          </div>
                          {getAttendeeProperty(people, "isPinned")
                            ? "Unpin"
                            : "Pin"}
                        </div>
                      </Dropdown.Item>
                    </>
                  ) : (
                    <>
                      {role !== "Attendee" && (
                        <Dropdown.Item onClick={() => displayUserProfile(people)}>
                          <div className="attendee-icon-menu ">
                            <div className="icon-block">
                              <i
                                data-icon-name="PeoplePaneAddPerson"
                                aria-hidden="true"
                                className="ms-ContextualMenu-icon icon-250"
                              >
                                <i
                                  className="fa-solid fa-user"
                                  aria-hidden="true"
                                ></i>
                              </i>
                            </div>
                            {getFirstName(peopleName)}
                          </div>
                        </Dropdown.Item>
                      )}
                      {inClass && (
                        <Dropdown.Item
                          onClick={() =>
                            handleAction(
                              getAttendeeProperty(people, "isPinned")
                                ? "Unpin"
                                : "Pin",
                              people
                            )
                          }
                        >
                          <div className="attendee-icon-menu ">
                            <div className="icon-block">
                              {getAttendeeProperty(people, "isPinned") ? (
                                <svg
                                  fill="currentColor"
                                  className="___12fm75w_v8ls9a0 f1w7gpdv fez10in fg4l7m0"
                                  aria-hidden="true"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  xmlns="http://www.w3.org/2000/svg"
                                  focusable="false"
                                >
                                  <path
                                    d="M2.85 2.15a.5.5 0 1 0-.7.7L6.9 7.6 4.02 8.75a1 1 0 0 0-.34 1.64L6.3 13 3 16.3v.7h.7L7 13.7l2.61 2.62a1 1 0 0 0 1.64-.34l1.15-2.88 4.75 4.75a.5.5 0 0 0 .7-.7l-15-15Zm8.78 10.18-1.31 3.28-5.93-5.93 3.28-1.3 3.96 3.95Zm1.33-1.62-.08.04.74.75 3.24-1.62a2 2 0 0 0 .52-3.2l-4.05-4.06a2 2 0 0 0-3.2.52L8.5 6.38l.75.74.04-.08 1.73-3.45a1 1 0 0 1 1.6-.26l4.05 4.05a1 1 0 0 1-.26 1.6l-3.45 1.73Z"
                                    fill="currentColor"
                                  ></path>
                                </svg>
                              ) : (
                                <svg
                                  fill="currentColor"
                                  className="___12fm75w_v8ls9a0 f1w7gpdv fez10in fg4l7m0"
                                  aria-hidden="true"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  xmlns="http://www.w3.org/2000/svg"
                                  focusable="false"
                                >
                                  <path
                                    d="M10.06 2.45a1.5 1.5 0 0 0-2.39.35L5.65 6.59l-2.8.94a.5.5 0 0 0-.2.82l2.14 2.15-2.64 2.65L2 14l.85-.15 2.65-2.64 2.15 2.14a.5.5 0 0 0 .82-.2l.94-2.8 3.78-2.03a1.5 1.5 0 0 0 .35-2.38l-3.48-3.5Z"
                                    fill="currentColor"
                                  ></path>
                                </svg>
                              )}
                            </div>
                            {getAttendeeProperty(people, "isPinned")
                              ? "Unpin"
                              : "Pin"}
                          </div>
                        </Dropdown.Item>
                      )}
                    </>
                  )}

                  <IframeModal />
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
      </div>
    </>
  );
}
export default memo(PeoplesTile);
